import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_path } from "../../shared.js";
export default function StageSummary({
  onStageClick,
  userId,
  empCode,
  salesId,
  salesTeam,
  salesRole,
}) {
  const [summary, setSummary] = useState([]);
  const [selectedStage, setSelectedStage] = useState(null);
  const url = `${api_path}/customer/get-customerStageSummary.php?userId=${userId}&empcode=${empCode}&salesId=${salesId}&salesTeam=${salesTeam}&salesRole=${salesRole}`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setSummary(res.data);
    });
  }, [userId,salesId]);

  const handleClick = (stage) => {
    const newStage =
      selectedStage && selectedStage === stage ? null : stage?.trim() || null;
    setSelectedStage(newStage);
    if (typeof onStageClick === "function") {
      onStageClick(newStage);
    }
  };

  // 🎨 สีแต่ละ Stage
  const stageColors = {
    Lead: "#fff", // เขียวอ่อน
    "In Contact": "#fff", // เหลืองอ่อน
    "Quotation Sent": "#fff", // ม่วงอ่อน
    "Closed - Won": "#fff", // ฟ้าอ่อน
    "Closed - Lost": "#fff", // แดงอ่อน
    "Follow-Up": "#fff", // ม่วงอ่อน
  };

  const borderColors = {
    Lead: "#4da6ff", // เขียว
    "In Contact": "#17a2b8", // เหลือง
    "Quotation Sent": "#ff5a5a", // ฟ้า
    "Closed - Won": "#198754", // ฟ้า
    "Closed - Lost": "#c92a2a", // แดง
    "Follow-Up": "#9c27b0", // ม่วง
  };
  const fontColors = {
    Lead: "#4da6ff", // เขียว
    "In Contact": "#17a2b8", // เหลือง
    "Quotation Sent": "#ff9800", // ฟ้า
    "Closed - Won": "#198754", // ฟ้า
    "Closed - Lost": "#c92a2a", // แดง
    "Follow-Up": "#9c27b0", // ม่วง
  };
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        marginBottom: 20,
        justifyContent: "center",
        width: "100%",
      }}
    >
      {Array.isArray(summary) && summary.length > 0 ? (
        summary.map((item) => {
          const bgColor = "#fff";
          const textColor =
            selectedStage === item.argument
              ? fontColors[item.argument]
              : "#2b2b2bff";

          return (
            <div
              key={item.argument}
              onClick={() => handleClick(item.argument)}
              style={{
                flex: "1 1 120px",
                border:
                  selectedStage === item.argument
                    ? `2px solid ${borderColors[item.argument] || "#0078d4"}`
                    : `1px solid ${borderColors[item.argument] || "#ccc"}`,
                borderRadius: 12,
                padding: 16,
                textAlign: "center",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                backgroundColor: bgColor,
                color: textColor,
                transition: "0.2s",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                {item.value}
              </div>
              <div>{item.argument}</div>
            </div>
          );
        })
      ) : (
        <div style={{ color: "#888" }}>ไม่มีข้อมูล</div>
      )}
    </div>
  );
}
